<template>
	<inertia-head title="BCC" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h3 class="fw-bold text-white mb-2">
						{{
							`Welcome to the ${$page.props.app.name} - Blockchain Circle (BCC)`
						}}
					</h3>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Blockchain Circle Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="alert border-top border-bottom border-start border-end border-primary shadow text-center" role="alert">
			<h3 class="alert-heading fs-3 fw-bold mb-1">{{selectedContent.title}}</h3>
			<p class="m-0">{{selectedContent.publish_by}} | {{selectedContent.date_start}}</p>
		</div>
		<div class="block block-rounded mt-5">
			<div class="block-content block-content-full">
				<div class="row">
					<div class="col text-center">
						<div style="padding: 56.25% 0 0 0; position: relative">
							<iframe
								:src="`https://player.vimeo.com/video/${selectedContent.vimeo_id}`"
								style="
									position: absolute;
									top: 0;
									left: 0;
									width: 100%;
									height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture" allowfullscreen
							></iframe>
						</div>
						<p class="mt-5 text-center" v-html="selectedContent.description"></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted, ref, watch } from 'vue';
import AuthLayout from '../../../Layouts/AuthLayout';

export default {
	layout: AuthLayout,
	props: {
		user 			: Object,
		bcc 			: Object,
		trc 			: Object,
		selectedContent : Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
		
	},
}
</script>
